import React, {useEffect, useState} from 'react';
import {Link, NavLink, Redirect, Route, Switch} from 'react-router-dom';
import {useQuery} from '@apollo/client';
import Avatar from '../components/Avatar';
import Icon from '../components/Icon';
import MyLessons from '../container/Lesson/List';
import Lesson from '../container/Lesson/Detail';
import TaskIntermediates from '../container/Task/Intermediates';
import UserDetail from '../container/User/Detail';
import Speaking from './Speaking';
import {QUERY_USER} from '../container/Client/graphql';
import TalkSave from '../container/Talk/Save';
import ForumList from '../container/Forum/List';
import ClientPayments from '../container/Client/Payments';
import ForumDetail from '../container/Forum/Detail';
import MaterialList from '../container/Material/List';
import MaterialDetail from '../container/Material/Detail';
import ClientGroups from '../container/Client/Groups';
import './styles.css';
import logo from '../logo.svg';
import Chat from '../container/Client/Chat';
import DocDetail from '../container/Doc/Detail';
import ThemeDetail from '../container/Theme/Detail';
import {useLocation} from 'react-router-dom';
import {Collapse, Dropdown} from 'bootstrap';
import ContestList from '../container/Contest/List';
import ContestDetail from '../container/Contest/Detail';
import ContestRating from '../container/Contest/Rating';

let bsCollapse;
let bsDropdown;

const Root = ({onLogout}) => {
  const params = new URLSearchParams(window.location.search);

  const [collapseToggle, setCollapseToggle] = useState(false);
  const [dropdownToggle, setDropdownToggle] = useState(false);

  const location = useLocation();
  const query = useQuery(QUERY_USER);

  const {user} = query.data;

  useEffect(() => {
    query.startPolling(5000);

    return () => {
      query.stopPolling();
    };
  }, []);

  useEffect(() => {
    bsCollapse = new Collapse(document.getElementById('navbarNav'), {toggle: false});
    bsDropdown = new Dropdown(document.getElementById('dropdown'), {});
  });

  useEffect(() => {
    collapseToggle ? bsCollapse.show() : bsCollapse.hide();
  }, [collapseToggle]);

  useEffect(() => {
    dropdownToggle ? bsDropdown.show() : bsDropdown.hide();
  }, [dropdownToggle]);

  useEffect(() => {
    bsCollapse.hide();
    setCollapseToggle(false);
    bsDropdown.hide();
    setCollapseToggle(false);
  }, [location]);

  return (
    <div className="Root">
      <header
        className="bg-white border-bottom border-info border-3 position-fixed"
        style={{left: 0, top: 0, height: 65, right: 0, zIndex: 1000}}
      >
        <nav className="container-fluid container-lg navbar text-white navbar-expand-lg h-100">
          <button
            onClick={() => setCollapseToggle(!collapseToggle)}
            className="btn btn-light text-info mx-2 d-lg-none"
            type="button"
            // data-bs-toggle="collapse"
            // data-bs-target="#navbarNav"
            // aria-controls="navbarNav"
            // aria-expanded="false"
            // aria-label="Toggle navigation"
          >
            {/*<span className="navbar-toggler-icon" />*/}
            <Icon name="bars" size={18} />
            <div className="font-1">Меню</div>
          </button>

          <a className="col-lg" href="/">
            <img src={logo} alt="Arine" height="30" />
          </a>

          <div className="col-lg me-2 me-lg-0 order-lg-last text-lg-end">
            <div id="dropdown" className="dropdown text-primary">
              <span
                onClick={() => setDropdownToggle(!dropdownToggle)}
                className="dropdown-toggle border-none"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="d-inline-block">
                  <Avatar user={user} size={36} color={dropdownToggle ? 'primary' : 'secondary'} />
                </div>
              </span>
              <ul className="dropdown-menu dropdown-menu-end py-3" aria-labelledby="dropdownMenuButton">
                <li className="border-bottom px-3 pb-3 mb-2">
                  <strong>{user.fullname}</strong>
                  <br />
                  <span className="text-secondary">{user.username}</span>
                  <br />
                  <span>ID: {('000000' + user.client.id).slice(-6)}</span>
                </li>
                <li>
                  <Link className="dropdown-item" to="/settings">
                    Настройки
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/payments">
                    Платежи
                  </Link>
                </li>
                {!!user.client.mentorings.length && (
                  <li>
                    <Link className="dropdown-item" to="/groups">
                      Модули
                    </Link>
                  </li>
                )}
                <li>
                  <button className="dropdown-item" onClick={onLogout}>
                    Выход
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div
            className="col-12 col-lg-auto collapse bg-white navbar-collapse justify-content-center py-3 py-lg-0 border-bottom border-3 border-lg-0 border-info"
            id="navbarNav"
          >
            <ul className="navbar-nav font-4 text-uppercase fw-bold">
              <li className="nav-item mx-3">
                <NavLink className="nav-link" to="/my-lessons">
                  Обучение
                </NavLink>
              </li>
              {/* <li className="nav-item mx-3">
                <NavLink className="nav-link" to="/speaking">
                  <span>Беседа</span>
                  {user.client.talkingId && (
                    <span className="ms-2">
                      <Icon name="volume-solid" color="warning" size={18} />
                    </span>
                  )}
                </NavLink>
              </li> */}
              <li className="nav-item mx-3">
                <NavLink className="nav-link" to="/forums">
                  Форум
                </NavLink>
              </li>
              <li className="nav-item mx-3">
                <NavLink className="nav-link" to="/materials">
                  Библиотека
                </NavLink>
              </li>
              <li className="nav-item mx-3">
                <NavLink className="nav-link" to="/contests">
                  Конкурс
                </NavLink>
              </li>
            </ul>
          </div>
        </nav>
      </header>
      <div style={{paddingTop: 65}}>
        <div className="container-fluid px-2 px-lg-0 container-lg">
          <Switch>
            <Redirect exact path="/" to="/my-lessons" />
            <Redirect exact path="/app" to="/my-lessons" />
            <Route path="/my-lessons" exact component={MyLessons} />
            <Route path="/my-lessons/:id" component={Lesson} />
            <Route path="/intermediate/:id" component={TaskIntermediates} />
            <Route path="/speaking/create" component={TalkSave} />
            <Route path="/speaking" component={Speaking} />
            <Route path="/themes/:id" component={ThemeDetail} exact />
            <Route path="/settings" component={UserDetail} />
            <Route exact path="/forums" component={ForumList} />
            <Route exact path="/forums/:id" component={ForumDetail} />
            <Route exact path="/payments" component={ClientPayments} />
            <Route exact path="/materials" component={MaterialList} />
            <Route exact path="/materials/:id" component={MaterialDetail} />
            <Route exact path="/docs/:id" component={DocDetail} />
            <Route exact path="/contests" component={ContestList} />
            <Route exact path="/contests/:id" component={ContestDetail} />
            <Route exact path="/contests/:id/rating" component={ContestRating} />
            <Route exact path="/groups" component={ClientGroups} />
          </Switch>
          <Chat />
        </div>
      </div>
      {/*<footer className="bg-primary">*/}
      {/*  <div className="container-fluid container-lg text-center text-white p-3">Quiz 2021</div>*/}
      {/*</footer>*/}
    </div>
  );
};

export default Root;
